import {both, complement, equals, isEmpty} from "ramda";

export const isNotEmpty = (value: any): boolean => !isEmpty(value);
export const notEquals = <T>(value1: T, value2: T): boolean => !equals(value1, value2);
export const isValidNumber = both((x: unknown): x is number => typeof x === "number", complement(Number.isNaN));
